import { NewWidgetDataFilterStepComponent } from './fi-new-widget-dialog/new-widget-data-filter-step/new-widget-data-filter-step.component';
import { FiNewWidgetDialogComponent } from './fi-new-widget-dialog/fi-new-widget-dialog.component';
import { WidgetDetailsTableComponent } from './fi-task-v2-report-widget-details/widget-details-content/widget-details-table/widget-details-table.component';
import { CompletedAfterDeadlineBadgeComponent } from './fi-task-v2-report-widget-details/completed-after-deadline-badge/completed-after-deadline-badge.component';
import { SystemTaskTooltipIconComponent } from './fi-task-v2-report-widget-details/system-task-tooltip-icon/system-task-tooltip-icon.component';
import { FiTaskV2ReportAssigneesCellComponent } from './fi-task-v2-report-widget-details/assignees-cell/fi-task-v2-report-assignees-cell.component';
import { WidgetDetailsHeaderComponent } from './fi-task-v2-report-widget-details/widget-details-header/widget-details-header.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTaskV2ReportComponent } from './fi-task-v2-report/fi-task-v2-report.component';
import { FiTaskV2ReportService } from './services/fi-task-v2-report.service';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiTaskV2ReportWidgetDetailsComponent } from './fi-task-v2-report-widget-details/fi-task-v2-report-widget-details.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiTaskV2ReportDataService } from './services/fi-task-v2-report-data.service';
import { FiTaskV2ReportTableFilterComponent } from './fi-task-v2-report-table-filter/fi-task-v2-report-table-filter.component';
import { FiMenuExpandableMultiSelectItemSearchModule } from '@fi-shared/fi-menu-expandable-multi-select-item-search/fi-menu-expandable-multi-select-item-search.module';
import { FiMenuFoldableMultiSelectItemSearchModule } from '@fi-shared/fi-menu-foldable-multi-select-item-search/fi-menu-foldable-multi-select-item-search.module';
import { FiMenuItemSearchModule } from '@fi-shared/fi-menu-item-search/fi-menu-item-search.module';
import { FiMenuMultiSelectItemSearchModule } from '@fi-shared/fi-menu-multi-select-item-search/fi-menu-multi-select-item-search.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FiTaskV2ReportTableFilterHelperService } from './services/fi-task-v2-report-table-filter-helper.service';
import { FiTaskV2ReportHelperService } from './services/fi-task-v2-report-helper.service';
import { FiTaskV2ReportWidgetComponent } from './fi-task-v2-report-widget/fi-task-v2-report-widget.component';
import { FiTaskV2ReportChartComponent } from './fi-task-v2-report-chart/fi-task-v2-report-chart.component';
import { FiTaskV2ReportItemOverviewDialogComponent } from './fi-task-v2-report-item-overview-dialog/fi-task-v2-report-item-overview-dialog.component';
import { FiReportWidgetModule } from '@fi-shared/fi-report-widget/fi-report-widget.module';
import { FiReportPieChartModule } from '@fi-shared/fi-report-pie-chart/fi-report-pie-chart.module';
import { FiChartHistoryModule } from '@fi-shared/fi-chart-history/fi-chart-history.module';
import { FiTask2ReportDateService } from './services/fi-task-v2-report-date.service';
import { MatButtonModule } from '@angular/material/button';
import { FiTimeRangeMenuModule } from '@fi-shared/fi-time-range-menu/fi-time-range-menu.module';
import { MatCardModule } from '@angular/material/card';
import { FiTaskV2SharedComponentsModule } from '../components/fi-task-v2-shared-components.module';
import { FiItemsListFilterModule } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { FiInfoBannerModule } from '@fi-app/shared/fi-info-banner/fi-info-banner.module';
import { TaskActionsBuilderService } from './fi-task-v2-report-widget-details/widget-details-content/widget-details-table/task-actions.builder.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiTaskOverviewTableWrapperComponent } from './fi-task-v2-report-item-overview-dialog/task-overview-table-wrapper/task-overview-table-wrapper.component';
import { FiLineClampModule } from '@fi-shared/fi-directives/fi-line-clamp/fi-line-clamp.module';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { FiProgressBadgeModule } from '@fi-app/shared/fi-progress-badge/fi-progress-badge.module';
import { WidgetDetailsContentComponent } from './fi-task-v2-report-widget-details/widget-details-content/widget-details-content.component';
import { FiTaskV2ReportWidgetFilterSettingsContentComponent } from './fi-new-widget-dialog/new-widget-data-filter-step/widget-filter-settings-content/widget-filter-settings-content.component';

@NgModule({
    imports: [
        CommonModule,
        FiLoadingModule,
        FiAppTextSharedModule,
        FiWrapperTableModule,
        MatTableModule,
        MatSortModule,
        FiWhenScrolledModule,
        FiMenuExpandableMultiSelectItemSearchModule,
        FiMenuFoldableMultiSelectItemSearchModule,
        FiMenuItemSearchModule,
        FiMenuMultiSelectItemSearchModule,
        MatMenuModule,
        MatIconModule,
        FiReportWidgetModule,
        DragDropModule,
        FiReportPieChartModule,
        FiChartHistoryModule,
        MatButtonModule,
        MatIconModule,
        FiTimeRangeMenuModule,
        MatCardModule,
        FiTaskV2SharedComponentsModule,
        FiItemsListFilterModule,
        InfoIconModule,
        FiAttachmentsModule,
        FiBindHtmlCompileModule,
        MatExpansionModule,
        MatDividerModule,
        FiInfoBannerModule,
        MatFormFieldModule,
        FormsModule,
        MatInputModule,
        FiFormatDateModule,
        FiLineClampModule,
        FiTooltipModule,
        FiProgressBadgeModule,
    ],
    declarations: [
        FiTaskV2ReportComponent,
        FiTaskV2ReportTableFilterComponent,
        FiTaskV2ReportWidgetComponent,
        FiTaskV2ReportItemOverviewDialogComponent,
        FiTaskV2ReportChartComponent,
        WidgetDetailsHeaderComponent,
        FiTaskV2ReportWidgetDetailsComponent,
        FiTaskV2ReportAssigneesCellComponent,
        SystemTaskTooltipIconComponent,
        CompletedAfterDeadlineBadgeComponent,
        WidgetDetailsTableComponent,
        FiNewWidgetDialogComponent,
        NewWidgetDataFilterStepComponent,
        FiTaskOverviewTableWrapperComponent,
        WidgetDetailsContentComponent,
        FiTaskV2ReportWidgetFilterSettingsContentComponent,
    ],
    providers: [
        FiTaskV2ReportService,
        FiTaskV2ReportDataService,
        FiTaskV2ReportHelperService,
        FiTaskV2ReportTableFilterHelperService,
        FiTask2ReportDateService,
        TaskActionsBuilderService,
    ],
})
export class FiTaskV2ReportModule {}
